import { getAreaId, isSameId } from "../../helpers";
export default function (store, { rowId, columnId, before }) {
    if (!columnId) {
        return;
    }
    const { areasMeta } = store.getState();
    const overAreaId = getAreaId(columnId, rowId);
    const dragItemArea = areasMeta[overAreaId];
    const moveInSameArea = isSameId(overAreaId, getAreaId(dragItemArea.columnId || "", dragItemArea.rowId));
    if (dragItemArea.noFreeSpace && !moveInSameArea) {
        return;
    }
    store.setState({
        overAreaId,
        before,
    });
}
//# sourceMappingURL=drag.js.map